import axios from "axios";
import { useState } from "react";
import Swal from "sweetalert2";
import logo from "../../../../../assets/used-icons/IvoryLogo.svg"
import { X } from "lucide-react";
import { useLanguage } from "../../../../../store/language-context";

export default function ServiceRegister({ setState }) {
    const { URL } = useLanguage();

    const [noAuthInput, setNoAuthInput] = useState({
        email: '',
        firstName: '',
        secondName: '',
        phone: '',
        isLoading: false,
        error: []
    });

    const subscribeWithNoAuth = async (e) => {
        e.preventDefault();
        setNoAuthInput(prev => ({ ...prev, isLoading: true }));

        const requestBody = {
            ivory_product_id: 1,
            email: noAuthInput.email,
            first_name: noAuthInput.firstName,
            last_name: noAuthInput.secondName,
            phone: noAuthInput.phone,
        };

        try {
            const response = await axios.post(`${URL}/ivory-products/store`, requestBody);

            if (response.status === 200) {
                Swal.fire({
                    icon: 'success',
                    title: 'تم التسجيل بنجاح',
                    text: 'تم الإشتراك في خدمة حلول التطوير القيادي',
                    confirmButtonText: 'موافق'
                })
                setState(false);
            } else if (response.status === 404) {
                // setState(false);
                Swal.fire({
                    icon: 'error',
                    title: 'فشل التسجيل',
                    text: 'الايميل او الرقم تم التسجيل بهم مسبقا',
                    confirmButtonText: 'موافق'
                });
            }
        } catch (error) {
            if (error?.status === 500) {
                setState(false);
                Swal.fire({
                    icon: 'error',
                    title: 'فشل الطلب',
                    text: 'حاول مرة اخرى',
                    confirmButtonText: 'حاول مرة أخرى'
                });
            }

            setNoAuthInput(prev => ({ ...prev, error: error?.response?.data?.data }))

        } finally {
            setNoAuthInput(prev => ({ ...prev, isLoading: false }));
        }
    };

    return (
        <>
            <div className="flex justify-center items-center px-6 fixed top-1/3  right-1/2 translate-x-1/2 -translate-y-1/3 z-[99999]">
                <div className="w-[50dvw] bg-white h-[50dvh] rounded-md max-md:w-[80dvw] max-lg:h-[96dvh] grid relative">
                    <button
                        className="absolute top-3 left-3 rounded-md border border-white text-white p-1"
                        onClick={() => {
                            setState(prev => !prev)
                            setNoAuthInput({
                                email: '',
                                secondName: '',
                                firstName: '',
                                phone: '',
                                companyTitle: '',
                                jobTitle: '',
                            })
                        }}>
                        <X size={16} />
                    </button>
                    <div className="border-b border-white bg-primary-tw rounded-t-md grid place-items-center">
                        <p className="text-white text-lg lg:text-2xl my-4">
                            التسجيل في خدمة حلول التطوير القيادي
                        </p>
                    </div>

                    <form method="POST" onSubmit={subscribeWithNoAuth} className="!text-start px-4 py-3 text-text-color space-y-2">
                        {/* first & second name */}
                        <div className="flex items-center gap-2 w-full max-lg:flex-col">
                            <div className="w-full">
                                <label htmlFor="firstName" className="flex items-center gap-2">
                                    <span>
                                        <img src={logo} alt="Ivory Logos" className="w-4" />
                                    </span>
                                    الإسم الأول
                                </label>
                                <input
                                    type="text"
                                    id="firstName"
                                    name="firstName"
                                    value={noAuthInput.firstName || ''}
                                    placeholder=" الإسم الأول هنا"
                                    onChange={(e) => setNoAuthInput(prev => ({
                                        ...prev,
                                        firstName: e.target.value
                                    }))}
                                    className="w-full rounded-md !my-2 py-1 px-2 text-black placeholder:py-2 bg-[#F5F5F5]"
                                    required
                                />
                            </div>

                            <div className="w-full">
                                <label htmlFor="secName" className="flex items-center gap-2">
                                    <span>
                                        <img src={logo} alt="Ivory Logos" className="w-4" />
                                    </span>
                                    الإسم الثاني
                                </label>
                                <input
                                    type="text"
                                    id="secName"
                                    name="secName"
                                    value={noAuthInput.secondName || ''}
                                    placeholder=" الإسم الثاني هنا"
                                    onChange={(e) => setNoAuthInput(prev => ({
                                        ...prev,
                                        secondName: e.target.value
                                    }))}
                                    className="w-full rounded-md my-2 py-1 px-2 text-black placeholder:py-2 bg-[#F5F5F5]"
                                    required
                                />
                            </div>
                        </div>

                        <div className="flex items-start gap-2 w-full max-lg:flex-col">
                            {/* email */}
                            <div className="w-full">
                                <label htmlFor="email" className="flex items-center gap-2">
                                    <span>
                                        <img src={logo} alt="Ivory Logos" className="w-4" />
                                    </span>
                                    البريد الإلكرتوني
                                </label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    value={noAuthInput.email || ''}
                                    placeholder="البريد الإلكرتوني هنا"
                                    onChange={(e) => setNoAuthInput(prev => ({
                                        ...prev,
                                        email: e.target.value
                                    }))}
                                    className={`w-full text-black rounded-md my-2 py-1 px-2 placeholder:py-2 bg-[#F5F5F5]`}
                                    required
                                />
                                {noAuthInput?.error?.some(item => item.includes("البريد الالكتروني"))
                                    && <p className="text-sm text-red-500">قمية حقل البريد الإلكرتوني مستخدمة من قبل</p>}
                            </div>

                            {/* phone number */}
                            <div className="w-full">
                                <label htmlFor="phone" className="flex items-center gap-2">
                                    <span>
                                        <img src={logo} alt="Ivory Logos" className="w-4" />
                                    </span>
                                    رقم الجوال
                                </label>
                                <input
                                    type="number"
                                    id="phone"
                                    name="phone"
                                    value={noAuthInput.phone || ''}
                                    placeholder="رقم الجوال هنا"
                                    onChange={(e) => setNoAuthInput(prev => ({
                                        ...prev,
                                        phone: e.target.value
                                    }))}
                                    className="w-full text-black rounded-md my-2 py-1 px-2 placeholder:py-2 bg-[#F5F5F5]"
                                    required
                                />
                                {noAuthInput?.error?.some(item => item.includes("الهاتف"))
                                    && <p className="text-sm text-red-500"> قمية حقل الهاتف  مستخدمة من قبل</p>}
                            </div>
                        </div>

                        <div className="flex items-center justify-center gap-2 w-full">
                            <button type="submit"
                                disabled={noAuthInput.isLoading}
                                className="w-full bg-primary-tw text-white rounded-md p-1 mt-6">
                                {noAuthInput.isLoading ? 'يتم التأكيد ...' : 'تأكيد'}
                            </button>
                            <button type="button" className="w-full bg-semi-gray text-white rounded-md p-1 mt-6"
                                disabled={noAuthInput.isLoading}
                                onClick={() => setNoAuthInput({
                                    email: '',
                                    firstName: '',
                                    secondName: '',
                                    phone: '',
                                    isLoading: false,
                                    error: []
                                })}>
                                إعادة تعيين
                            </button>

                        </div>
                    </form>
                </div>
            </div>
            <div className="fixed top-0 right-0 w-dvw h-full bg-black/80 z-[9999]"
                onClick={() => {
                    setState(prev => !prev)
                    setNoAuthInput({
                        email: '',
                        secondName: '',
                        firstName: '',
                        phone: '',
                    })
                }}></div>
        </>
    )
}